import { useContext } from "react";
import { ThemeContext } from "styled-components";

function useThemeColor(themeColor: string): string {
  const themeContext = useContext(ThemeContext);

  return themeContext?.colors[themeColor] || themeColor;
}

export default useThemeColor;
